import React, {Component} from "react";
import PropTypes from "prop-types";
import {withRouter} from "react-router-dom";
import {connect} from "react-redux";
import {imageCdnUrls} from "../../common/ImageCdnUrls";
import {UPDATE_RECIPIENT_TYPE_SELECTION} from "../../../actions/communications/newCommunicationAction";

class NewCommunicationRecipientTypeSelector extends Component {

    static propTypes = {
        selectedRecipientType: PropTypes.string,
        updateRecipientTypeSelection: PropTypes.func
    };

    constructor(props, context) {
        super(props, context);
    }

    render() {
        const {selectedRecipientType, updateRecipientTypeSelection} = this.props;

        const mapSelectionClassName = `recipient-type-option${selectedRecipientType === 'map' ? ' selected' : ''}`;
        const listSelectionClassName = `recipient-type-option${selectedRecipientType === 'list' ? ' selected' : ''}`;
        const groupSelectionClassName = `recipient-type-option${selectedRecipientType === 'group' ? ' selected' : ''}`;

        return (
            <div className="recipient-type-selector-form">
                <div className="modal-body-title">
                    How would you like to add recipients?
                </div>
                <div className="recipient-type-options">
                    <div className={mapSelectionClassName} onClick={() => updateRecipientTypeSelection('map')}>
                        <div className="recipient-type-option-img">
                            <img src={imageCdnUrls.comm_add_map} width="39" height="48"/>
                        </div>
                        <div className="recipient-type-option-text">
                            <div className="recipient-type-option-header">Add by map</div>
                            <div className="recipient-type-option-description">Choose from location of contacts</div>
                        </div>
                    </div>
                    <div className={listSelectionClassName} onClick={() => updateRecipientTypeSelection('list')}>
                        <div className="recipient-type-option-img">
                            <img src={imageCdnUrls.comm_add_list} width="44" height="47"/>
                        </div>
                        <div className="recipient-type-option-text">
                            <div className="recipient-type-option-header">Add by list</div>
                            <div className="recipient-type-option-description">Choose from your list of contacts</div>
                        </div>
                    </div>
                    <div className={groupSelectionClassName} onClick={() => updateRecipientTypeSelection('group')}>
                        <div className="recipient-type-option-img">
                            <img src={imageCdnUrls.comm_add_group} width="44" height="47"/>
                        </div>
                        <div className="recipient-type-option-text">
                            <div className="recipient-type-option-header">Add by group</div>
                            <div className="recipient-type-option-description">Choose from your group of contacts</div>
                        </div>
                    </div>
                </div>
            </div>);
    }
}

const mapStateToProps = state => ({
    selectedRecipientType: state.newCommunication.selectedRecipientType
});

const mapDispatchToProps = dispatch => ({
    updateRecipientTypeSelection: (selectBy) => dispatch({type: UPDATE_RECIPIENT_TYPE_SELECTION, selectBy: selectBy})
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(NewCommunicationRecipientTypeSelector));
